//Importación de librerias
//---------------SISEVA---------------
//Catalogos
import ModalConfirmacion from '../../../src/components/SISEVA/Comun/ModalConfirmacion.vue'


//Creamos y asignamos los datos necesarios de siseva
const siseva = [
  { Proviene: 'SISEVA', Nombre: 'ModalConfirmacion', datos: ModalConfirmacion }
]


//Exportamos los datos de siseva
export default siseva;



//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/siseva.js
// module id = null
// module chunks = 